import { render, staticRenderFns } from "./LicenseSetting.vue?vue&type=template&id=961ddfaa&scoped=true&"
import script from "./LicenseSetting.vue?vue&type=script&lang=js&"
export * from "./LicenseSetting.vue?vue&type=script&lang=js&"
import style0 from "./LicenseSetting.vue?vue&type=style&index=0&id=961ddfaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ddfaa",
  null
  
)

export default component.exports